<div class="spinner-container d-flex justify-content-center align-items-center py-5">
  <div class="spinner-border text-warning" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
